import apiClient from './api';

const API_URL = '/skills';

/**
 * Ensure standard skills exist
 */
export const ensureStandardSkills = async () => {
  const response = await apiClient.post(`${API_URL}/ensure-standard`);
  return response.data;
};

/**
 * Bulk assign skill to all users or specific users
 */
export const bulkAssignSkill = async (skillName: string, userIds?: string[]) => {
  const response = await apiClient.post(`${API_URL}/bulk-assign`, {
    skillName,
    userIds,
  });
  return response.data;
};

/**
 * Assign skill to users by name
 */
export const assignSkillToUsersByName = async (skillName: string, userNames: string[]) => {
  const response = await apiClient.post(`${API_URL}/assign-by-name`, {
    skillName,
    userNames,
  });
  return response.data;
};

/**
 * Remove skill from users
 */
export const removeSkillFromUsers = async (skillName: string, userIds: string[]) => {
  const response = await apiClient.delete(`${API_URL}/remove`, {
    data: { skillName, userIds },
  });
  return response.data;
};

/**
 * Get all users with a specific skill
 */
export const getUsersBySkill = async (skillName: string) => {
  const response = await apiClient.get(`${API_URL}/${skillName}/users`);
  return response.data.data;
};

/**
 * Update a user's skills
 */
export const updateUserSkills = async (userId: string, skillNames: string[]) => {
  const response = await apiClient.put(`${API_URL}/users/${userId}`, {
    skillNames,
  });
  return response.data;
};

/**
 * Bulk update user skills
 */
export const bulkUpdateUserSkills = async (
  updates: Array<{ userId: string; skillNames: string[] }>
) => {
  const response = await apiClient.put(`${API_URL}/users/bulk`, {
    updates,
  });
  return response.data;
};

/**
 * Get all skills for a user
 */
export const getUserSkills = async (userId: string) => {
  const response = await apiClient.get(`${API_URL}/users/${userId}`);
  return response.data.data;
};

/**
 * Seed initial skills (one-time setup)
 */
export const seedInitialSkills = async () => {
  const response = await apiClient.post(`${API_URL}/seed-initial`);
  return response.data;
};

